import React from "react";
import { Link } from "react-router";

const Breadcrumb = ({ items }) => {
  return (
    <div className="flex items-center gap-2 text-base font-semibold text-[#005856]">
      {items.map((item, index) => (
        <React.Fragment key={item.path || item.label}>
          {index > 0 && <span className="text-[#005856]">&gt;</span>}
          {index === items.length - 1 ? (
            <span className="text-[#005856]">{item.label}</span>
          ) : (
            <Link
              to={item.path}
              className="text-[#005856] no-underline transition-opacity hover:opacity-80"
            >
              {item.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Breadcrumb;
